import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Modal, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useInstallPrompt } from "../../contexts/useInstallContext";

export default function InstallDialog() {
  const { showPrompt, promptInstall, dismissPrompt } = useInstallPrompt();

  return (
    <Modal sx={{          
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: "center",
    }}
       open={showPrompt} onClose={dismissPrompt}>
      <Box
        className="patlite"
        sx={{
          marginTop: "15vh",
          padding: 4,
          marginRight: 4,
          marginLeft: 4,
          boxShadow: 24,
          backgroundColor: "rgba(255,255,255,0.95)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          alignSelf: "center",
          gap: 2,
          maxWidth: 300,
        }}
      >
        {/* Close button top right */}
        <IconButton
          onClick={dismissPrompt}
          sx={{ position: "fixed", top: 8, right: 8 }}
          aria-label="close install prompt"
        >
          <CloseIcon />
        </IconButton>

        <img
          src="src_assets/header_logo.svg"
          alt="Eco Eats Logo"
          style={{ width: 60, alignSelf: "center" }}
        />
        <Typography variant="h6" textAlign="center">
          Install Eco Eats
        </Typography>
        <Typography variant="body1" textAlign="center">
          Install this app to your device for a better, faster experience.
        </Typography>
        <Button
          sx={{ background: "#162C1F", border: "1px solid #162C1F", borderRadius: "24px" }}
          onClick={promptInstall}
          variant="contained"
          fullWidth
        >
          Install
        </Button>
      </Box>
    </Modal>
  );
}
